module.exports = __webpack_public_path__ + "media/assets/learnerstudio-61feb53defbead9eb39cde903418f891.png";